$(document).on("turbolinks:load", function () {
  if ($('#js-notifications').is('*')) {
    if ($('#js-notifications .loader').is('*')) {
      $('#js-notifications').on('mouseover', function(){
        $.get({
          url: $('#js-notifications').data('url'),
          type: "GET",
          beforeSend: function(xhr){
            xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
          },
          dataType: "script",
          success: function() {
            $('#js-notifications').unbind('mouseover');
            // Bind read_at call to unread notifications
            setTimeout(function(){
              bindReadAt();
            },
            1000);
          }
        });
      });  
    }
  }

  bindReadAt();
  bindMarkAllRead();

  if ($('.js-filter-notifications-form').is('*')){
    filterForm();
  }
});

function bindMarkAllRead(){
  $('body').off('click.bpMarkAllRead', '.js-mark-all-read').on('click.bpMarkAllRead', '.js-mark-all-read', function(e){
    e.preventDefault();

    var button = $(this);
    if (button.hasClass('is-marking') || button.hasClass('is-marked')) { return; }

    button
      .addClass('is-marking disabled')
      .attr('aria-disabled', 'true')
      .html('<i class="fad fa-spinner-third fa-spin mr-2"></i>Mark All Read');

    $.ajax({
      url: button.attr('href'),
      type: "POST",
      beforeSend: function(xhr){
        xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
      },
      dataType: "json",
      success: function(){
        $('#js-notifications-table .js-unread-notification').removeClass('js-unread-notification table-primary');
        button
          .removeClass('is-marking disabled btn-dark')
          .addClass('is-marked btn-success')
          .css({ 'pointer-events': 'none', 'transition': 'none' })
          .html('<i class="fas fa-check mr-2"></i>All Read');
      },
      error: function(){
        button
          .removeClass('is-marking disabled')
          .removeAttr('aria-disabled')
          .html('<i class="fas fa-check mr-2"></i>Mark All Read');
        window.notyf.error("Something went wrong. Please try again.");
      }
    });
  });
}

function bindReadAt() {
  $('body').off('mouseover.bpReadAt', '.js-unread-notification').on('mouseover.bpReadAt', '.js-unread-notification', function(){
    var notification = $(this);
    notification.removeClass('js-unread-notification'); // Stop re-firing on subsequent hovers (and survives ajax pagination via delegation).
    $.get({
      url: notification.data('url'),
      type: "POST",
      beforeSend: function(xhr){
        xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
      },
      dataType: "json",
      data: { notification_id: notification.data('notification') },
      success: function(){
        notification.removeClass('table-primary');
      }
    });
  });
}

function filterForm(){
  $('.js-filter-notifications-form').off('change.bpFilter').on('change.bpFilter', function(){
    var form = $(this);
    var filter = form.find('select').val();
    var base = form.attr('action');
    var query = filter ? ('filter=' + encodeURIComponent(filter)) : '';

    window.history.replaceState({}, '', query ? (base + '?' + query) : base);
    loadNotificationsTable(base + '?' + (query ? query + '&' : '') + 'remote=true');
  });
}

function loadNotificationsTable(url){
  var container = $('#js-notifications-table');
  container.html('<p class="text-center p-4 pt-5"><i class="fad fa-spinner-third fa-spin text-secondary fa-2x"></i></p>');

  fetch(url, { credentials: 'same-origin' })
    .then(function(response){ return response.text(); })
    .then(function(html){
      container.html(html);
      $('[data-toggle="tooltip"]').tooltip();
    });
}